@if(seekPosition()){

<div class="seek-preview-container">
    @if(previewUrl()){
    <div class="seek-preview">
        <img [src]="previewUrl()" alt="seek preview" />
    </div>
    }
    <div class="seek-preview-current-time">
        <span>{{ (seekPosition() * 1000 ) | date:'HH:mm:ss':'UTC'}}</span>
    </div>
</div>

}